<div class="card-inline-audit" *ngIf="isAuditing">
  <h4>Paciente</h4>
  <button *ngIf="!readOnly" (click)="edit()" mat-mini-fab>
    <mat-icon>edit</mat-icon>
  </button>
  <div class="spacer"></div>
  <button
    *ngIf="isPatientDataValidated"
    (click)="revertControlled()"
    [disabled]="loadingAuditPatient"
    mat-flat-button
    color="primary"
    type="button"
    style="margin-left: 5px; margin-bottom: 5px"
  >
    Revertir controlado
  </button>

  <button
    *ngIf="!isPatientDataValidated"
    (click)="validateControlled()"
    [disabled]="loadingAuditPatient"
    mat-flat-button
    color="primary"
    type="button"
    style="margin-left: 5px; margin-bottom: 5px"
  >
    Controlado
  </button>
</div>

<div *ngIf="!isAuditing" class="card-inline">
  <h3>Paciente</h3>
</div>
<div *ngIf="!isAuditing" class="card-inline">
  <button *ngIf="!readOnly" (click)="edit()" mat-mini-fab>
    <mat-icon>edit</mat-icon>
  </button>

  <button
    *ngIf="canChangePasswordAutogesion && !readOnly"
    (click)="changePasswordAutogesion()"
    mat-flat-button
  >
    Cambiar contraseña en autogestión
  </button>
</div>
<mat-divider></mat-divider>
<div class="margin-top-medium">
  <form [formGroup]="patientViewFormGroup">
    <div *ngIf="isAuditing">
      <ng-container *ngTemplateOutlet="detalleTemplate"></ng-container>
    </div>

    <mat-tab-group *ngIf="!isAuditing">
      <mat-tab label="Detalle">
        <ng-container *ngTemplateOutlet="detalleTemplate"></ng-container>
      </mat-tab>

      <mat-tab
        *ngIf="!canViewMedicalPatientInfo && !isAuditing"
        label="Datos familiares"
      >
        <mat-form-field class="medium-width margin-right-medium">
          <input
            matInput
            formControlName="MotherFirstName"
            placeholder="Nombre de la madre"
          />
        </mat-form-field>
        <mat-form-field class="medium-width">
          <input
            matInput
            formControlName="MotherLastName"
            placeholder="Apellido de la madre"
          />
        </mat-form-field>
        <mat-form-field class="medium-width margin-right-medium">
          <input
            matInput
            formControlName="FatherFirstName"
            placeholder="Nombre del padre"
          />
        </mat-form-field>
        <mat-form-field class="medium-width">
          <input
            matInput
            formControlName="FatherLastName"
            placeholder="Apellido del padre"
          />
        </mat-form-field>
      </mat-tab>

      <mat-tab
        *ngIf="!canViewMedicalPatientInfo && !isAuditing"
        label="Datos de cobertura"
      >
        <mat-form-field class="medium-width margin-right-medium">
          <input
            type="text"
            #entity
            matInput
            placeholder="Entidad"
            formControlName="Entity"
          />
        </mat-form-field>

        <mat-form-field class="medium-width">
          <input
            type="text"
            matInput
            placeholder="Plan"
            formControlName="Plan"
          />
        </mat-form-field>

        <mat-form-field class="medium-width margin-right-medium">
          <input
            type="text"
            matInput
            placeholder="Alícuota"
            formControlName="AliquotTax"
          />
        </mat-form-field>

        <mat-form-field class="medium-width">
          <input
            type="text"
            matInput
            placeholder="Número de credencial"
            formControlName="CredentialNumber"
          />
        </mat-form-field>
      </mat-tab>
    </mat-tab-group>

    <ng-template #detalleTemplate>
      <mat-form-field class="margin-right-xs margin-top-xx">
        <input
          matInput
          placeholder="Tipo documento"
          formControlName="DocumentType"
        />
      </mat-form-field>
      <mat-form-field class="margin-right-xs margin-top-xx">
        <input matInput placeholder="Número" formControlName="Number" />
      </mat-form-field>
      <mat-form-field class="margin-right-xs">
        <input matInput placeholder="Apellido" formControlName="LastName" />
      </mat-form-field>
      <mat-form-field class="margin-right-xs">
        <input matInput placeholder="Nombre" formControlName="FirstName" />
      </mat-form-field>
      <mat-form-field class="margin-right-xs">
        <input matInput placeholder="Pid" formControlName="Pid" />
      </mat-form-field>
      <mat-form-field class="margin-right-xs">
        <input
          matInput
          placeholder="Fecha nacimiento"
          formControlName="BirthDate"
        />
      </mat-form-field>
      <mat-form-field class="margin-right-xs">
        <input matInput placeholder="Sexo" formControlName="Sex" />
      </mat-form-field>
      <mat-form-field *ngIf="seePatientContactInfo" class="margin-right-xs">
        <input matInput placeholder="País" formControlName="Country" />
      </mat-form-field>
      <mat-form-field *ngIf="seePatientContactInfo" class="margin-right-xs">
        <input matInput placeholder="Provincia" formControlName="Province" />
      </mat-form-field>
      <mat-form-field *ngIf="seePatientContactInfo" class="margin-right-xs">
        <input matInput placeholder="Localidad" formControlName="Locality" />
      </mat-form-field>
      <mat-form-field *ngIf="seePatientContactInfo" class="margin-right-xs">
        <input
          matInput
          placeholder="Código postal"
          formControlName="AddressCP"
        />
      </mat-form-field>
      <mat-form-field *ngIf="seePatientContactInfo" class="margin-right-xs">
        <input matInput placeholder="Calle" formControlName="AddressStreet" />
      </mat-form-field>
      <mat-form-field *ngIf="seePatientContactInfo" class="margin-right-xs">
        <input matInput placeholder="Nro" formControlName="AddressNumber" />
      </mat-form-field>
      <mat-form-field *ngIf="seePatientContactInfo" class="margin-right-xs">
        <input matInput placeholder="Piso" formControlName="Floor" />
      </mat-form-field>
      <mat-form-field *ngIf="seePatientContactInfo" class="margin-right-xs">
        <input matInput placeholder="Depto." formControlName="AddressDpto" />
      </mat-form-field>
      <mat-form-field *ngIf="seePatientContactInfo" class="margin-right-xs">
        <input
          matInput
          placeholder="Teléfono particular"
          formControlName="PersonalPhone"
        />
      </mat-form-field>
      <mat-form-field *ngIf="seePatientContactInfo" class="margin-right-xs">
        <input
          matInput
          placeholder="Teléfono laboral"
          formControlName="LaborPhone"
        />
      </mat-form-field>
      <mat-form-field *ngIf="seePatientContactInfo" class="margin-right-xs">
        <input matInput placeholder="Celular" formControlName="CellPhone" />
      </mat-form-field>
      <mat-form-field *ngIf="seePatientContactInfo" class="margin-right-xs">
        <input matInput placeholder="Email" formControlName="Email" />
      </mat-form-field>

      <div>
        <mat-form-field
          *ngIf="seePatientContactInfo && !isAuditing"
          class="margin-right-xs"
        >
          <input
            matInput
            placeholder="Teléfono emergencias"
            formControlName="EmergencyPhone"
          />
        </mat-form-field>
        <mat-form-field
          *ngIf="!isAuditing"
          class="relevance-input margin-right-xs"
        >
          <textarea
            matInput
            placeholder="Relevancia"
            formControlName="Relevance"
          ></textarea>
        </mat-form-field>

        <mat-form-field
          *ngIf="!canViewMedicalPatientInfo && !isAuditing"
          class="relevance-input margin-right-xs"
        >
          <textarea
            matInput
            placeholder="Diagnóstico"
            formControlName="Diagnostics"
          ></textarea>
        </mat-form-field>
        <br *ngIf="freeDiagnostic && !isAuditing" />
        <h4 *ngIf="freeDiagnostic && !isAuditing">Diagnóstico</h4>
        <br *ngIf="freeDiagnostic && !isAuditing" />
        <div
          *ngIf="freeDiagnostic && !isAuditing"
          [innerHtml]="freeDiagnostic"
        ></div>
        <br *ngIf="freeDiagnostic && !isAuditing" />
      </div>
      <div *ngIf="!isAuditing">
        <mat-form-field class="margin-right-xs">
          <input
            matInput
            placeholder="Disca. permatente (CUD)"
            formControlName="DisabilityPermanent"
          />
        </mat-form-field>
      </div>

      <mat-form-field
        *ngIf="canViewMedicalPatientInfo && !isAuditing"
        class="margin-right-xs"
      >
        <input matInput placeholder="Peso" formControlName="Weight" />
      </mat-form-field>
      <mat-form-field
        *ngIf="canViewMedicalPatientInfo && !isAuditing"
        class="margin-right-xs"
      >
        <input matInput placeholder="Altura (mts)" formControlName="Height" />
      </mat-form-field>
      <mat-form-field
        *ngIf="canViewMedicalPatientInfo && !isAuditing"
        class="margin-right-xs"
      >
        <input
          matInput
          placeholder="Claustrofóbico"
          formControlName="Claustrophobia"
        />
      </mat-form-field>
      <mat-form-field
        *ngIf="canViewMedicalPatientInfo && !isAuditing"
        class="margin-right-xs"
      >
        <input matInput placeholder="Marcapasos" formControlName="Pacemaker" />
      </mat-form-field>
      <mat-form-field
        *ngIf="canViewMedicalPatientInfo && !isAuditing"
        class="margin-right-xs"
      >
        <input
          matInput
          placeholder="Partes metálicas"
          formControlName="MetallicPart"
        />
      </mat-form-field>
      <mat-form-field
        *ngIf="canViewMedicalPatientInfo && !isAuditing"
        class="margin-right-xs"
      >
        <input
          matInput
          placeholder="Disca. temporal/embarazo/bebé"
          formControlName="DisabilityTemporal"
        />
      </mat-form-field>
    </ng-template>
  </form>
</div>
